<template>
  <div>
    <p>La température de l’air diminue avec l’altitude.</p>
    <p>
      Selon le niveau d’altitude du bâtiment, la sensation d’inconfort l’été
      peut donc varier.
    </p>
  </div>
</template>
